import { render, staticRenderFns } from "./CourseInstructorPage.vue?vue&type=template&id=c90f9372&scoped=true"
import script from "./CourseInstructorPage.vue?vue&type=script&lang=js"
export * from "./CourseInstructorPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90f9372",
  null
  
)

export default component.exports